<template>
  <IconLucideFolderX />
</template>
